<template>
  <IconLucideFolderX />
</template>
